import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import { FaUserAlt, FaTable, FaListUl, FaEdit, FaTimes } from 'react-icons/fa'
import { HiPencilAlt, HiOutlineTrash } from 'react-icons/hi'
import Search from '../../Helper/CustomSearch'
import axios, { post, get } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import config from '../../../config'
import empty from 'is-empty'
import Breadcrumbs from '../../Helper/Breadcrumbs'
import Loader from '../../Helper/Loader';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import { Pagination } from '@mui/material'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

const icon = `${process.env.PUBLIC_URL}/img/images/order-images.jpg`;

const EventVendorList = (props) => {
    // console.log('props in EventVendorList',props)
    // console.log('props.history.location.state',props.history.location.state)
    let history = useHistory();
    let tokenKey = { headers: { Authorization: 'Token ' + sessionStorage.getItem('tokenKey') } };
    let propsState = props.history.location.state;
    let idFromRole = JSON.parse(sessionStorage.getItem('permission'))[0].vendor_ids[0] || null
    let vendorId = propsState && propsState.id ? propsState.id : idFromRole;
    let toastAttr = {
        theme: "colored",
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    };
    const [tableData, settableData] = useState([]);
    const [loading, setloading] = useState(true);
    const [view, setview] = useState('list');
    const [searchTerm, setsearchTerm] = useState(null);
    const [page, setpage] = useState({ page: 1, count: 1, total: 0, next: null, previous: null });
    const [showDelete, setshowDelete] = useState(false);
    const [selRow, setSelRow] = useState(null)


    const setLoader = (val) => {
        setloading(val);
    }
    let mapVal = {
        veg: 'Veg',
        non_veg: 'Non-veg',
        both: 'Veg & Non-veg'
    }

    let breadcrumbData = [
        {
            title: 'Event Vendor',
            href: '#'
        }
    ]

    const manipulateData = (res, pageNum) => {
        let count = Math.ceil(res.data.count / 10)
        setpage({ page: pageNum || page.page, count: count, total: res.data.count, next: res.data.next, previous: res.data.previous });
        settableData(res.data.results || res.data);
        setLoader(false);
    }


    const getVendorList = (pageNum = 1, search = searchTerm) => {
        setLoader(true);
        let url = config.service + '/v2/event-vendors/admin/list/?&page=' + pageNum;
        if (!empty(search)) url += '&search=' + search;
        get(url, tokenKey).then(res => {
            manipulateData(res, pageNum);
            setsearchTerm(search);
        }).catch(err => {
            setLoader(false);
            if (err.response && err.response.status === 401) window.location.href = '/';
        })
    }

    const handlePagination = (e, newPage) => {
        getVendorList(newPage);
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
    }

    const handleTablePagination = (type, { page }) => {
        if (type === 'pagination') {
            getVendorList(page);
            window.scrollTo({
                top: 0,
                behavior: 'instant',
            })
        }
    }

    const handleClose = () => { setshowDelete(false); setSelRow(null) };

    const deleteRow = () => {
        setshowDelete(false)
        setLoader(true);
        axios.delete(config.service + '/v2/event-vendors/admin/list/' + selRow.id, tokenKey).then(resp => {
            getVendorList(1);
        }).catch(err => {
            if (err.response && err.response.status === 401) window.location.href = '/'; setLoader(false);
            toast.error('Deletion Failed', toastAttr);
        })
    }

    const renderForm = () => {
        history.push({
            pathname: '/eventVendorForm',
            state: {
                vendor_id: vendorId,
                tabValue: 'details'
            }
        })
    }

    const renderOnSearch = searchTerm => {
        getVendorList(1, searchTerm);
    }

    useEffect(() => {
        getVendorList(1);
    }, []);
    const cols = [
        {
            dataField: 'business_name',
            text: 'Business Name',
            headerStyle: () => { return { width: '400px' } },
            formatter: (cell, row) => {
                return (
                    <div>{cell}</div>
                )
            }
        }
    ];

    const rowEvents = {}

    let options = paginationFactory({
        page: page.page,
        sizePerPage: 20,
        paginationSize: 3,
        hideSizePerPage: true,
        hidePageListOnlyOnePage: true,
        totalSize: page.total
    })

    return (
        <Container className="vendor">
            <Row>
                <Col md={12} className='contBody'>
                    <Card>
                        <CardBody>
                            <div className="card__title pageNav">
                                <div className="bold-text">
                                    <Breadcrumbs data={breadcrumbData} />
                                </div>
                            </div>
                            <Row className='formBtnsDiv mar-b-10'>
                                <Col md={8}>
                                    <Button variant='primary' onClick={e => renderForm()}>Create</Button>
                                </Col>
                                <Col md={4}>
                                    <Search callbackFn={e => renderOnSearch(e)} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className='viewIcons'>
                                        <span><FaListUl title='Card View' onClick={() => { setview('list') }} /></span>
                                        <span><FaTable title='List View' onClick={() => { setview('table') }} /></span>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='vendorList'>
                                <Loader loading={loading}>
                                    {view === 'list' ?
                                        tableData.length > 0 ? tableData.map(row => {
                                            let img = icon;
                                            {
                                                row.image_ids && row.image_ids.length > 0 && row.image_ids.map(obj => {
                                                    if (obj.cover_image) img = obj.image;
                                                })
                                            }

                                            return (
                                                <Col md={5} className='divCont' style={{ display: 'block' }}>
                                                    <Row>
                                                        <Col md={5}>
                                                            <div className='child' style={{ margin: '15px 0' }}>
                                                                {row.cover_image ? (
                                                                    <img className="mandapImage" src={row.cover_image} alt="event vendor" style={{ height: '100px', width: '100px' }} />
                                                                ) : (
                                                                    <div className="mandapImage d-flex align-items-center justify-content-center   text-white font-weight-bold" style={{ fontSize: '2rem', borderRadius: '4px', height: '100px', width: '100px', backgroundColor: '#ee448b' }}>
                                                                        {row.business_name ? row.business_name.charAt(0).toUpperCase() : '?'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col md={5}>
                                                            <div className='child' style={{ marginTop: '25px', padding: '10px' }}>
                                                                <div className='mandapHeader'>Business Name : <span>{row.business_name} </span></div>
                                                                {/* Add other details to display card view */}
                                                                <div className='mandapHeader'> Status : <span>{row.status} </span></div>
                                                                <div className='mandapHeader'>contact person : <span>{row.contact_person ? row.contact_person : 'N/A'}</span></div>
                                                                <div className='mandapHeader'> Category : <span>{row.category} </span></div>
                                                            </div>
                                                        </Col>
                                                        <Col md={2}>
                                                            <div className='child' style={{ margin: '15px 0' }}>
                                                                {/* <HiPencilAlt className='color-green actionIcon' onClick={e => renderForm(row)} /> */}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            )
                                        }) : <div className='textCenter'>No data found</div>
                                        : <BootstrapTable remote bootstrap4 wrapperClasses='table-responsive  pad-20' data={tableData} columns={cols}
                                            keyField='id' containerStyle={{ width: '100%' }} hover noDataIndication='No data found' rowEvents={rowEvents}
                                            pagination={options} onTableChange={handleTablePagination} />
                                    }
                                    {view === 'list' && !empty(tableData) ? <Row className='common-pagination'>
                                        <Col md={6} />
                                        <Col md={6}>
                                            <Pagination className='paginate' count={page.count} page={page.page} onChange={handlePagination} color='primary' />
                                        </Col>
                                    </Row> : ''}
                                </Loader>
                                <Col md={6}></Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Dialog open={showDelete} onClose={handleClose} maxWidth='md'>
                <DialogTitle>Confirm Deletion <FaTimes onClick={() => setshowDelete(false)} className='popup-close' title='close' /></DialogTitle>
                <DialogContent>
                    <div style={{ paddingRight: '30px' }}>Are you sure to delete ?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteRow}>Delete</Button>
                    <Button onClick={handleClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Container>
    );
};

export default EventVendorList;
